import { render, staticRenderFns } from "./BusinessKindDialog.vue?vue&type=template&id=d4873a28&scoped=true&"
import script from "./BusinessKindDialog.vue?vue&type=script&lang=js&"
export * from "./BusinessKindDialog.vue?vue&type=script&lang=js&"
import style0 from "./BusinessKindDialog.vue?vue&type=style&index=0&id=d4873a28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4873a28",
  null
  
)

export default component.exports